import isPlainObject from './isPlainObject';
import flattenWhenNode from './flattenWhenNode';

export default flattenWhenNode(isPlainObject);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/flattenActionMap.js
// module id = ./node_modules/redux-actions/es/utils/flattenActionMap.js
// module chunks = 6 9 11